import { render } from "./Form.vue?vue&type=template&id=1500f3d3&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=1500f3d3&lang=scss&scoped=true"
import "./Form.vue?vue&type=style&index=1&id=1500f3d3&lang=scss"

import exportComponent from "/builds/ct-dev/clickcease/google-health-report-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1500f3d3"]])

export default __exports__